<template>
  <div>
    <app-page-container title="ماموریت ها">
      <template v-slot:header>
        <v-col cols="4" class="mr-n11">
          <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense v-model="searchTitle"
            class="mt-3"></v-text-field>
        </v-col>
        <v-spacer></v-spacer>
        <div class="leftItemTop">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon id="iconDatabase" size="28" color="#464646" @click="openColumnManager" v-bind="attrs" v-on="on">
                mdi-database-edit
              </v-icon>
            </template>
            <span>
              چیدمان جدول
            </span>
          </v-tooltip>
        </div>
      </template>
      <template v-slot:body>
        <v-row no-gutters class="background-main">
          <v-col cols="12">
            <v-card elevation="0" class="body-card card-width pa-0">
              <v-card-text class="pa-0">
                <v-row no-gutters>
                  <v-col cols="12" class="pa-0">
                    <template>
                      <v-data-table :items="doctorMissions" :defaultHeaders="doctorTableInformationHeader"
                        :headers="currentHeaders.filter(h => h.isActive !== false)"
                        :items-per-page="doctorMissions.length" height="80vh" fixed-header :search="searchTitle"
                        :hide-default-footer="true" multi-sort dence id="table-doctor" class="elevation-0 table-doctor"
                        @dblclick:row="showDoctorInformationModal" @contextmenu:row="rightClickHandler">
                        <template v-slot:[`item.icon`]="{ item }">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon :class="item.iconClass" :color="item.iconColor" v-bind="attrs" v-on="on">
                                mdi-car-emergency mdi-18px
                              </v-icon>
                            </template>
                            <span>وضعیت {{ item.rank }}</span>
                          </v-tooltip>
                        </template>
                        <template v-slot:no-data>
                          <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                        </template>
                      </v-data-table>
                    </template>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </template>
      <template v-slot:append>
        <section>
          <confirm-dialog ref="confirm">
            <v-row slot="action" no-gutters>
              <v-spacer></v-spacer>
              <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
                style="color: white" @click="confirmDialogConfirmFunction()" :disabled="disabelConfirm">
                بله
              </v-btn>
              <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
                @click="confirmDialogCancelFunction()">
                خیر
              </v-btn>
            </v-row>
          </confirm-dialog>
          <v-dialog width="90%" v-model="orderModal" persistent style="z-index: 1">
            <doctor-order-component v-if="orderModal" :missionPhoneId="missionPhoneId" :missionId="missionId"
              :phoneId="phoneId"></doctor-order-component>
          </v-dialog>
        </section>
        <section>
          <alert-component style="z-index: 999999999999999999999 !important" ref="snackRef" :snakTimeOut="snakTimeOut"
            :snackColor="snackColor" :snackText="snackText" :snakIcon="snakIcon"></alert-component>

        </section>
      </template>
    </app-page-container>
    <v-menu v-model="showMenu" :position-x="x" :position-y="y" absolute :close-on-content-click="closeOnContentClick"
      offset-y style="z-index: 99999999999">
      <v-list dense>
        <v-list-item-group>
          <v-list-item v-for="(item, index10) in rightClickItems" :key="'qq' + index10" dense>
            <v-list-item-icon>
              <v-icon color="darkColor">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="mr-n8 mt-n2" v-if="item.title == 'تماس داخلی'">
              <v-list-group>
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-text-field label="شماره تماس" dense v-model="iternalPhoneNumber">
                  <template v-slot:append-outer>
                    <v-btn x-small color="darkColor" dark class="py-3" @click="rightClickAction(item.title, null)">
                      <v-icon color="white">mdi-phone mdi-18px mdi-flip-h</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-list-group>
            </v-list-item-content>
            <v-list-item-content class="mr-n8 mt-n2" v-if="item.title == 'تماس خارجی'">
              <v-list-group>
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-text-field placeholder="شماره تماس" dense small v-model="externalPhoneNumber">
                  <template v-slot:append-outer>
                    <v-btn x-small color="darkColor" dark class="py-3" @click="rightClickAction(item.title, null)">
                      <v-icon color="white">mdi-phone-forward mdi-18px mdi-flip-h</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-list-group>
            </v-list-item-content>
            <v-list-item-content class="mr-n8 mt-n2" v-if="item.title == 'تماس با کد'">
              <v-list-group>
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item @click="rightClickAction(item.title, codePhoneNumbers)">
                  <v-list-item-content>
                    <v-list-item-title class="mr-3">{{ codePhoneNumbers }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </v-list-item-content>
            <v-list-item-content class="mr-n8 mt-n2" v-if="item.title == 'تماس با مددجو'">
              <v-list-group>
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item v-for="(sitem, index) in patientPhoneNumbers" :key="'c' + index"
                  @click="rightClickAction(item.title, sitem)">
                  <v-list-item-content>
                    <v-list-item-title class="mr-3">{{ sitem }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>

    <column-manager-dialog :is-reverse="false" v-model="showColumnManager" :headers="currentHeaders"
      :defaultHeaders="doctorTableInformationHeader" :fixedValues="['icon']" @submit="applyNewHeaders" />
  </div>


</template>
<script>
import confirmDialog from '@/components/ConfirmDialog.vue';
import throttle from 'lodash/throttle'; // rate-limits socket-driven refreshes; trailing:true guarantees the LAST signal is never dropped
import AlertComponent from '@/components/AlertComponent.vue';
import DoctorOrderComponent from '@/components/Doctor/DoctorOrderComponent.vue';
import AppPageContainer from '@/components/app/PageContainer.vue';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import MissionPhonesMixin from '@/Mixins/Mission/MissionPhonesMixin.js';
import DoctorMissionsHelper from '@/Helpers/Doctor/DoctorMissionsHelper.js';
import CallMixin from '@/Mixins/Call/CallMixin';
import UserGridSettingsMixin from '@/Mixins/BaseInformation/UserGridSettingsMixin.js';
import ColumnManagerDialog from '@/components/800/ColumnManagerDialog.vue';

export default {
  name: 'DoctorMissions',
  title: 'پزشک',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    confirmDialog,
    AlertComponent,
    DoctorOrderComponent,
    AppPageContainer,
    ColumnManagerDialog
  },
  mixins: [ShearedMixin, DoctorMissionsHelper, snackBar, ShearedHelper, MissionPhonesMixin, CallMixin, UserGridSettingsMixin],
  created() {
    this.$root.$refs.DoctorMissions = this;
    this.currentHeaders = [...this.doctorTableInformationHeader];

    this.throttledMainListDoctor = throttle(this.fMainListDoctor, 1500, {
      leading: true,
      trailing: true,
    });

    this.$mainSignalr.bus.$on('MainListDoctor', this.throttledMainListDoctor);
    this.$mobileSignalr.bus.$on('MainListDoctor', this.throttledMainListDoctor);
  },
  beforeDestroy() {
    // must $off with the SAME function reference that was passed to $on
    this.$mainSignalr.bus.$off('MainListDoctor', this.throttledMainListDoctor);
    this.$mobileSignalr.bus.$off('MainListDoctor', this.throttledMainListDoctor);

    // drop any queued trailing invocation so a dead component never fetches
    this.throttledMainListDoctor.cancel();

    delete this.$root.$refs.DoctorMissions;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {
      showColumnManager: false,
      currentHeaders: [],
      doctorListRefreshInFlight: false, // true while a refresh request is running
      doctorListRefreshPending: false,  // a signal arrived DURING a refresh -> run one more after it finishes
    };
  },
  methods: {
    mounte: function () {
      this.refreshDoctorList(true); // initial load (with loading indicator) through the same guarded pipeline
      const tables = document.getElementsByTagName('table');
      this.resizableGrid(tables[0]);

      this.getAllUserGridSettingsFunction('MainListDoctor').then((resolve) => {

        if (resolve?.length > 0) {
          let temp = resolve?.find((item) => item?.gridName == 'MainListDoctor');
          if (temp?.settingsJson) {
            try {
              this.currentHeaders = JSON.parse(temp?.settingsJson);
            } catch (e) {
              this.currentHeaders = [...this.doctorTableInformationHeader];
            }
          } else {
            this.currentHeaders = [...this.doctorTableInformationHeader];
          }
        } else {
          this.currentHeaders = [...this.doctorTableInformationHeader];
        }
      })
    },
    fMainListDoctor: function () {
      this.refreshDoctorList(false);
    },
    refreshDoctorList: async function (showLoading = false) {
      if (this.doctorListRefreshInFlight) {
        this.doctorListRefreshPending = true;
        return;
      }
      this.doctorListRefreshInFlight = true;
      try {
        await this.getListOfCurrentMissionsForDoctorFunction(showLoading);
      } catch (error) {
        console.log('refreshDoctorList error:', error);
      } finally {
        this.doctorListRefreshInFlight = false;
        if (this.doctorListRefreshPending) {
          this.doctorListRefreshPending = false;
          this.refreshDoctorList(false); // trailing refresh is signal-driven -> no loading indicator
        }
      }
    },
    resizableGrid(table) {
      const element = document.getElementsByClassName('v-data-table__wrapper')[0];
      element.scrollLeft += element.scrollWidth + 30;
      let row = table.getElementsByTagName('tr')[0],
        cols = row ? row.children : undefined;
      if (!cols) return;
      table.style.overflow = 'scroll';
      table.style.tableLayout = 'fixed';
      let tableHeight = table.offsetHeight;

      const drag = { curCol: null, pageX: 0, curColWidth: 0, tableStartWidth: 0, delta: 0 };

      for (let p = 0; p < cols.length; p++) {
        cols[p].style.width = (cols[p].offsetWidth - paddingDiff(cols[p])) + 'px';
      }

      for (let i = 0; i < cols.length; i++) {
        let div = createDiv(tableHeight);
        cols[i].appendChild(div);
        cols[i].style.position = 'relative';
        setListeners(div);
      }
      function disableSortEvent() {
        const thElements = document.querySelectorAll('th');
        thElements.forEach((th) => {
          th.style.pointerEvents = 'none';
        });
      }
      function enableSortEvent() {
        const thElements = document.querySelectorAll('th');
        thElements.forEach((th) => {
          th.style.pointerEvents = 'auto';
        });
      }

      function onMouseMove(e) {
        if (!drag.curCol) return;
        let diffX = e.pageX - drag.pageX;
        let newWidth = Math.max(40, drag.curColWidth - diffX); // clamp: no vanishing columns
        drag.delta = newWidth - drag.curColWidth; // remembered for mouseup normalization

        drag.curCol.style.width = newWidth + 'px';
        table.style.width = (drag.tableStartWidth + drag.delta) + 'px';

        if (drag.wrapperIsRtl) {
          // native RTL wrapper: the browser anchors content to the RIGHT edge and
          // measures scroll from it, so table growth extends LEFT on its own —
          // columns after the dragged one slide left naturally and the dragged
          // edge tracks the cursor. Any scroll compensation here CANCELS that
          // natural shift (this was the bug), so: do nothing.
        } else {
          // LTR wrapper: pin the table's RIGHT edge with a margin shift ->
          // columns left of the drag slide left, view and scrollbar stay still
          table.style.marginLeft = (-drag.delta) + 'px';
        }
      }

      function onMouseUp() {
        enableSortEvent(); // restore header sorting after the drag
        // convert the temporary margin shift into a real scroll offset, so the
        // far-left columns remain reachable after the drag ends
        if (drag.curCol && !drag.wrapperIsRtl && drag.delta) {
          table.style.marginLeft = '';
          drag.wrapper.scrollLeft = Math.max(0, drag.wrapperStartScroll + drag.delta);
        }
        drag.curCol = null;
        drag.delta = 0;
        // listeners exist only while dragging -> nothing accumulates
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
      }

      function setListeners(div) {
        div.addEventListener('mousedown', function (e) {
          disableSortEvent(); // clicking the handle must not trigger Vuetify column sort
          e.stopPropagation();
          e.preventDefault(); // stop text selection while dragging
          drag.curCol = e.target.parentElement;
          drag.pageX = e.pageX;
          drag.delta = 0;
          drag.curColWidth = drag.curCol.offsetWidth - paddingDiff(drag.curCol);
          drag.tableStartWidth = table.offsetWidth;

          // snapshot the scroll container once per drag
          drag.wrapper = table.closest('.v-data-table__wrapper') || element;
          drag.wrapperIsRtl = getStyleVal(drag.wrapper, 'direction') === 'rtl';
          drag.wrapperStartScroll = drag.wrapper.scrollLeft;

          document.addEventListener('mousemove', onMouseMove);
          document.addEventListener('mouseup', onMouseUp);
        });

        div.addEventListener('mouseover', function (e) {
          e.stopPropagation();
          e.target.style.borderLeft = '2px solid #0000ff'; // indicator on the grab edge
        });

        div.addEventListener('mouseout', function (e) {
          e.stopPropagation();
          e.target.style.borderLeft = '';
        });
      }
      function createDiv(height) {
        const div = document.createElement('div');
        div.style.top = 0;
        div.style.left = 0; // RTL: resize from the column's LEFT edge
        div.style.width = '5px';
        div.style.position = 'absolute';
        div.style.cursor = 'col-resize';
        div.style.userSelect = 'none';
        div.style.height = height + 'px';
        div.style.zIndex = 10;
        return div;
      }
      function paddingDiff(col) {
        if (getStyleVal(col, 'box-sizing') == 'border-box') {
          return 0;
        }

        let padLeft = getStyleVal(col, 'padding-left');
        let padRight = getStyleVal(col, 'padding-right');
        return parseInt(padLeft) + parseInt(padRight);
      }
      function getStyleVal(elm, css) {
        return window.getComputedStyle(elm, null).getPropertyValue(css);
      }
    },
    getRealColumnWidths() {
      const table = document.querySelector('#table-doctor table');
      if (!table) {
        return null;
      }

      const headerCells = table.querySelectorAll('thead tr th');
      if (!headerCells.length) {
        return null;
      }

      const widths = [];
      headerCells.forEach((th) => {
        const width = th.getBoundingClientRect().width;
        widths.push(Math.round(width));
      });
      return widths;
    },
    openColumnManager() {
      const realWidths = this.getRealColumnWidths();

      if (realWidths) {
        const headersWithWidth = this.currentHeaders.map((h, index) => ({
          ...h,
          width: realWidths[index] ? realWidths[index] : (h.width || 120),
        }));

        this.currentHeaders = headersWithWidth;
      }

      this.showColumnManager = true;
      const icon = document.getElementById('iconDatabase');
      if (icon) icon.blur();
    },
    applyNewHeaders(newHeaders) {
      this.currentHeaders = newHeaders;
      this.setUserGridSettingFunction({
        gridName: "MainListDoctor",
        settingsJson: JSON.stringify(newHeaders)
      })
    },
  },
};
</script>
<style lang="scss">
#table-doctor>.v-data-table__wrapper>table>thead>tr {
  position: sticky;
  z-index: 1;
  background: white;
  top: 0;
}

#table-doctor>.v-data-table__wrapper>table {
  &>tbody>tr>td {
    border-right: 1px solid grey !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &>thead>tr>th {
    border-right: 1px solid grey !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

#table-doctor>.v-data-table__wrapper>table>tbody>tr>td {
  font-size: 15px !important;
  font-weight: 600;
  color: #212121 !important;
}

#table-doctor>.v-data-table__wrapper table>thead>tr>th {
  font-size: 17px !important;
  font-weight: 700 !important;
  color: #212121 !important;
}

#table-doctor>.v-data-table__wrapper {
  direction: rtl !important;
}
</style>
<style scoped>
>>>.table-doctor .v-data-table__wrapper table {
  table-layout: fixed;
}

.leftItemTop {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
  margin-right: auto;
  margin-left: 35px;
}

.modal-header {
  border-bottom: 2px solid let(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.confirm-cancel-btn {
  border: solid 1px let(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: let(--dark-color);
}

.modal-title-text {
  color: let(--dark-color);
  font-weight: 500;
  font-size: 16px;
}

.card-add-phoneNumber {
  border: 2px solid #cdcbcf !important;
}

.card-add-phoneNumber-items {
  margin-top: -7px !important;
}

.card-add-phoneNumber-items-text {
  color: #cdcbcf !important;
}

.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}

.inside-cards {
  border: 1px solid let(--dark-color) !important;
  overflow-y: auto !important;
}

.dialog-part-divider-text {
  color: #212121;
  font-size: 14px;
  font-weight: 600;
}

.chip-text {
  color: let(--dark-color) !important;
}

.rank-icon-anim1 {
  animation: shake 0.5s;
  animation-iteration-count: infinite;
}

.rank-icon-anim2 {
  animation: shake2 0.5s;
  animation-iteration-count: infinite;
}

@keyframes shake {
  0% {
    transform: translate(1px, 1px) rotate(0deg);
  }

  10% {
    transform: translate(-1px, -2px) rotate(-1deg);
  }

  20% {
    transform: translate(-3px, 0px) rotate(1deg);
  }

  30% {
    transform: translate(3px, 2px) rotate(0deg);
  }

  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }

  50% {
    transform: translate(-1px, 2px) rotate(-1deg);
  }

  60% {
    transform: translate(-3px, 1px) rotate(0deg);
  }

  70% {
    transform: translate(3px, 1px) rotate(-1deg);
  }

  80% {
    transform: translate(-1px, -1px) rotate(1deg);
  }

  90% {
    transform: translate(1px, 2px) rotate(0deg);
  }

  100% {
    transform: translate(1px, -2px) rotate(-1deg);
  }
}

@keyframes shake2 {
  0% {
    transform: rotate(0deg);
  }

  25% {
    transform: rotate(5deg);
  }

  50% {
    transform: rotate(0eg);
  }

  75% {
    transform: rotate(-5deg);
  }

  100% {
    transform: rotate(0deg);
  }
}

th {
  position: sticky !important;
  top: 0 !important;
  background: white !important;
  z-index: 9 !important;
}
</style>
